/** @format */

import { Component, Input } from '@angular/core';

import { IPromotion } from '@category/data-access';
import { TaggingService } from '@shared/data-access/services';

@Component({
	selector: 'clp-promotion-banner',
	template: `
		<a
			*ngIf="promotion"
			[href]="promotion.url"
			[attr.data-em]="createTag('hat', promotion.message, promotion.details)">
			<span class="bold">{{ promotion.message }}</span>
			{{ promotion.details }}
			<u>{{ promotion.detailsMessage }}</u>
		</a>
	`,
	styleUrl: './promotion-banner.component.scss',
	standalone: false
})
export class PromotionBannerComponent {
	@Input() promotion: IPromotion;

	createTag = TaggingService.createSimpleTag;
}
